const isExternalUrl = (url) => {
    return /(^\/\/|:\/\/|mailto:|^\/?.0\/)/.test(url);
};

/**
 * Generated bundle index. Do not edit.
 */

export { isExternalUrl };
